import { useRoutes } from 'react-router-dom';
import MainRoutes, { WebviewLayout } from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import NoAuthenticationRoutes from './NoAuthenticationRoutes';

export default function ThemeRoutes() {
  return useRoutes([
    MainRoutes,
    AuthenticationRoutes,
    NoAuthenticationRoutes.NotFoundRoute,
    NoAuthenticationRoutes.NoPermissionRoute,
    WebviewLayout,
  ]);
}
